import { Grid, Modal, Paper, Typography } from "@mui/material";
import AdminSidebar from "./Sidebar";
import { AddAPhoto } from "@mui/icons-material";
import { useEffect, useState } from "react";

const position = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    width: 300,
    background: 'white',
    border: 'none !important'
}

export default function Settings() {

    const [file, setFile] = useState(null);
    const handleChange = (e) => {
        var filedata = e.target.files[0];
        // setFile(URL.createObjectURL(e.target.files[0]))
        var fileurl = URL.createObjectURL(filedata);
        setFile(fileurl);
    }
    const [modal, setmodal] = useState(false);
    useEffect(() => {
        if (file != null) {
            handleChangeModal();
            console.log('done')
        } else {
            console.log('n ot')
        }
    }, [file])

    const handleChangeModal = () => {
        setmodal(!modal)
    }
    const handleChangeModalWithFile = () => {
        setmodal(!modal);
        setFile(null);
    }
    return (
        <>

            <Grid container>
                <AdminSidebar />
                <Grid container alignItems={'center'} justifyContent={'space-around'} size={{ lg: 10 }}>
                    <Grid size={{ lg: 5 }} className='bg-admin-navy text-white' p={3} borderRadius={2}>
                        <Typography variant="h5">Change Logo</Typography>
                        <Grid className='mt-3 settings-logo' sx={{ background: 'linear-gradient(to left,rgb(0,0,0,0.5),rgb(0,0,0,0.5)),url("https://cdn.iconscout.com/icon/free/png-256/free-zomato-logo-icon-svg-download-png-1637644.png")' }}>
                            {/* <img src="https://cdn.iconscout.com/icon/free/png-256/free-zomato-logo-icon-svg-download-png-1637644.png" className="settings-logo mt-3" /> */}
                            <label for='file'>
                                <AddAPhoto sx={{ fontSize: 300, color: 'black' }} className="float-end cursor-pointer" />
                            </label>
                            <input type="file" onChange={handleChange} className="form-control d-none" name="file" id="file" />
                        </Grid>

                    </Grid>
                    <Grid size={{ lg: 5 }}></Grid>
                    <Modal onClose={handleChangeModal} open={modal}>
                        <Paper sx={[position, { padding: 2 }]}>
                            <img src={file} className="img-fluid" />
                            <div className="d-flex flex-wrap justify-content-between">
                                <button className="btn-admin-navy w-48 py-2 mt-3">Change</button>
                                <button onClick={handleChangeModalWithFile} className="btn-outline-admin-navy w-48 py-2 mt-3">Cancel</button>
                            </div>
                        </Paper>
                    </Modal>
                </Grid>
            </Grid>

        </>
    )

}